<template>
    <div id="message_list">
        <div class="message_list">
            <div class="message_list1">
                <div class="message_list2">导师课堂</div>
                <div class="flex-row" style="width: 100%;">
                    <div style="width: 80%;">
                        <TabSwitcher :value="titleIndex" :tabs="list" @change="titleSelect" />
                    </div>
                    <div style="flex: 1;text-align: right;">
                        <el-button @click.stop="toBuyHistory" type="primary" size="small" style="font-size: 16px;">
                            <svg-icon iconClass="pay" class="custom" style="font-size: 20px;" />
                            购买记录</el-button>
                    </div>
                </div>

            </div>
            <div class="message_list7" v-if="list.length == 0">
                <noData></noData>
            </div>
            <div class="message_list7" ref="scrollContainer" v-else>
                <div class="classroom-list t-m-t-20">
                    <div class="classroom-list__item" v-for="(item, i) in curList" :key="i"
                        @click.stop="toDetail(item.id)">
                        <div class="cover" :style="{ backgroundImage: `url(${item.pcCover})` }"></div>

                        <div class="classroom-list__doc">
                            <p class="title">{{ item.title }}</p>
                            <p class="desc">{{ item.releaseTime }}</p>
                        </div>
                        <div class="classroom-list__doc2">
                            <div class="flex-row">
                                <div class="avatar" :style="{ backgroundImage: `url(${item.mentorHead})` }">
                                </div>
                                <span class="avatar_name">{{ item.mentorName }}</span>
                            </div>
                            <!-- <el-button type="default" style="padding: 0 5px;height: 30px;line-height: 30px;font-size: 12px;">立即跳转</el-button> -->
                            <div class="classroomBtn" @click.stop="toDetail(item.id)">查看详情</div>
                        </div>
                    </div>
                </div>
                <div ref="loader" class="loader">
                    <div v-if="loading">加载中...</div>
                    <!-- <div v-if="!hasMore">没有更多数据了</div> -->
                </div>
            </div>
        </div>
        <!-- 参考格式弹框 -->
        <tipPopup ref="tipPopup"></tipPopup>
    </div>
</template>
<script>
import CApi from '@/api/classroom.js';
import { EventBus } from '@/utils/eventBus'
import noData from '@/components/no_data.vue';
import TabSwitcher from '@/components/contactUs/TabSwitcher.vue'
import tipPopup from '@/components/classroom/tip_popup.vue'
import { scrollerMixin } from '@/mixin/scrollerMixin';
export default {
    mixins: [scrollerMixin],
    components: {
        noData, TabSwitcher, tipPopup
    },
    data() {
        return {
            titleIndex: -1,
            list: [{ name: '全部', level: '' }],//总数组
            level: '',//初始化级别
            curList: [],//当前选中的数组
            pageNum: 1
        }
    },
    created() {
        this.levelsList()
        this.getUserLoginState(false)
    },
    mounted() {
        const kc_tip = localStorage.getItem('kc_tip')
        if (!kc_tip || kc_tip === 'false') {
            this.$refs.tipPopup.openPopup()
        }
    },
    watch: {
        // 监听 list 变化，数据加载完成后初始化观察器
        list() {
            this.$nextTick().then(_ => {
                this.initObserver({
                    scrollRequest: () => {
                        this.getList()
                    }
                })
            })
        }
    },
    methods: {
        //分类
        levelsList() {
            CApi.levelsList().then(res => {
                if (res.code === 200) {

                    this.list = this.list.concat(res.data || [])
                    if (this.list.length > 0) {
                        this.curList = []
                        this.titleSelect(0, this.list[0])
                    }
                }
            })
        },
        //获取分类列表
        async getList() {
            this.loading = true;
            try {
                const response = await CApi.classroomList({ pageNum: this.pageNum, level: this.level })
                if (response.code === 200) {
                    this.curList = [...this.curList, ...response.data];
                    this.pageNum++;
                    this.hasMore = response.data.length >= 10;
                } else {
                    this.$message.warning(response.msg)
                }

            } catch (error) {
                console.error('滚动分页出现问题:', error);
            } finally {
                this.loading = false;
            }
        },
        //选中
        titleSelect(index, item) {
            if (this.titleIndex === index) return
            this.pageNum = 1
            this.titleIndex = index
            this.level = item.level
            this.curList = []
            this.getList()
        },
        toDetail(id) {
             if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            this.$router.push({ path: '/classroom_detail', query: { detailId: id } })
        },
        toBuyHistory() {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            this.$router.push({ path: '/classroom_history' })
        },
    }
}
</script>
<style lang="scss" scoped>
p {
    padding: 0;
    margin: 0;
}

#message_list {
    flex: 1;
    width: 60%;
    overflow: auto;
}

.message_list {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
}

.message_list1 {
    padding: 20px;
    position: relative;
    border-bottom: 1px solid #E6EBF0;
    display: flex;
    flex-direction: column;
}

.message_list2 {
    font-weight: bold;
    font-size: 18px;
    color: #0B0B0B;
    margin-bottom: 15px;
}

.message_list7 {
    width: 100%;
    padding: 0 20px;
    flex: 1;
    overflow: auto;
    box-sizing: border-box;
    @include scrollbar();

    &:hover {
        @include scrollbar_hover()
    }
}

.classroom-list {
    display: grid;
    gap: 18px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    box-sizing: border-box;
}

.classroom-list__item {
    width: 100%;
    margin-bottom: 18px;
    padding-bottom: 16px;
    border-radius: 12px;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid rgba(17, 25, 37, .15);
    cursor: pointer;
    display: flex;
    flex-direction: column;

    &:hover {
        box-shadow: 0 4px 12px #0000001f;
    }

    .cover {
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
        background-color: #f5f5f5;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
    }
}

.classroom-list__doc {
    width: 100%;
    padding: .75rem;
    border-bottom: 1px solid var(--tech-btn-border2);
    box-sizing: border-box;

    .title {
        font-size: 18px;
    }

    .desc {
        padding-top: .4rem;
        font-size: 14px;
        color: #8f8f8f;
    }
}

.classroom-list__doc2 {
    padding-top: .75rem;
    padding-left: .75rem;
    padding-right: .75rem;
    box-sizing: border-box;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .avatar {
        width: 30px;
        min-width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        background-color: #f5f5f5;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .avatar_name {
        margin-left: .5rem;
    }
}

.loader {
    font-size: 16px !important;
    grid-column: 1 / -1;
    /* 让加载器占满整行 */
    text-align: center;
    padding: 20px;
}
</style>